var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationHomeIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 7.03132V17.1563H5.60942V13.6744C5.60942 11.8885 7.05786 10.44 8.84384 10.44C9.73822 10.44 10.5454 10.8028 11.1304 11.3878C11.7154 11.9728 12.0782 12.78 12.0782 13.6743V17.1562H17.0001V7.03125L8.84395 0.84375L0.6875 7.03132Z",
    fill: "#334B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationHomeIconDark);
export default __webpack_public_path__ + "static/media/location_home_icon_dark.a3dbb02c1c21cba2ad49af0fdc1f4d2c.svg";
export { ForwardRef as ReactComponent };